import React from 'react';
import { IVendorProductGroupingVendorVariant } from '@components/pages/ProductV3/shared/types';
import { IVendorVariantInternal } from '../../models/VendorVariant/i-vendor-variant';

/* istanbul ignore next */
const VendorVariantContext = React.createContext<
IVendorVariantInternal | IVendorProductGroupingVendorVariant
>(
  {} as IVendorVariantInternal | IVendorProductGroupingVendorVariant
);

export default VendorVariantContext;
